<template>
  <div>
    <span v-if="data.column.field === 'details'">
      <div class="d-flex align-items-center justify-content-between">
        <span>
          <div
            v-if="data.row.insertedByUser != null"
            class="text-muted"
          >
            <span class="pr-50">{{ $tk('ClientPortal.ApiKey.CreatedBy') }}</span>
            <b-avatar
              v-b-tooltip.hover.top="`${data.row.insertedByUser.displayName}`"
              variant="transparent"
              class="avatar"
              size="20px"
              :src="data.row.insertedByUser.avatar"
            />
            {{ `${$tk('ClientPortal.ApiKey.At')} ${getFormattedDate(data.row.insertedByUser.dateTime)}` }}
          </div>
          <div
            v-if="data.row.updatedByUser != null"
            class="text-muted"
          >
            {{ $tk('ClientPortal.ApiKey.UpdatedBy') }}
            <b-avatar
              v-b-tooltip.hover.top="`${data.row.updatedByUser.displayName}`"
              variant="transparent"
              class="avatar"
              size="20px"
              :src="data.row.updatedByUser.avatar"
            />
            {{ `${$tk('ClientPortal.ApiKey.At')} ${getFormattedDate(data.row.updatedByUser.dateTime)}` }}
          </div>
        </span>
        <b-dropdown
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template v-slot:button-content>
            <GjIcon
              name="Moreoptions_fill"
              class="text-body align-middle mr-25"
            />
          </template>
          <div v-if="data.row.status !== 3">
            <b-dropdown-item
              v-b-modal.modal-apikey-delete
              @click="setApiKeyModel(data.row, 'Regenerate')"
            >
              <GjIcon
                name="Refresh"
                class="mr-50"
              />
              <span> {{ $tk('ClientPortal.Form.Actions.Regenerate') }}</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-b-modal.modal-add-APIKey
              @click="setApiKeyModel(data.row, 'Edit')"
            >
              <GjIcon
                name="Edit"
                class="mr-50"
              />
              <span> {{ $tk('ClientPortal.Form.Actions.Edit') }}</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-b-modal.modal-apikey-delete
              @click="setApiKeyModel(data.row, 'Revoke')"
            >
              <GjIcon
                name="Close"
                class="mr-50"
              />
              <span> {{ $tk('ClientPortal.Form.Actions.Revoke') }}</span>
            </b-dropdown-item>
          </div>
          <b-dropdown-item
            v-b-modal.modal-apikey-delete
            @click="setApiKeyModel(data.row, 'Delete')"
          >
            <GjIcon
              name="Delete"
              class="mr-50"
            />
            <span> {{ $tk('ClientPortal.Form.Actions.Delete') }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </span>
    <span v-else-if="data.column.field === 'expirationDate'">
      {{ getFormattedDate(data.row.expirationDate) }}
    </span>
    <span v-else-if="data.column.field === 'status'">
      {{ ApiKeyStatus[data.row.status] }}
    </span>
    <span v-else-if="data.column.field === 'roleId'">
      {{ userRoles.find(role => role.id === data.row.roleId).name }}
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'
import translation from '@/mixins/translate'
import {
  computed,
} from '@vue/composition-api'

const ApiKeyStatus = {
  1: translation.methods.$tk('ClientPortal.Admin.ApiKeys.Active'),
  2: translation.methods.$tk('ClientPortal.Admin.ApiKeys.Expired'),
  3: translation.methods.$tk('ClientPortal.Admin.ApiKeys.Revoked'),
}

export default {

  components: {
    GjIcon,
  },
  props: {
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const setApiKeyModel = (data, action) => {
      const model = { ...data, action }
      store.commit('SET_API_KEY_MODEL', model)
    }
    const userRoles = computed(() => store.getters.getUserRoles)
    const getFormattedDate = date => date.slice(0, 10)
    return {
      getFormattedDate,
      setApiKeyModel,
      ApiKeyStatus,
      userRoles,
    }
  },
}
</script>
